import "./tarifsSumeryEntry.css";

function TarfisSumeryEntry({ name, price, domicile, atelier }) {
  return (
    <div className="sumery-entry-row">
      <div className="sumery-entry-name">{name}</div>
      <div className="sumery-entry-price">{price}</div>
      <div className="sumery-entry-site">
        À Domicile : {domicile}
        <br />
        En Atelier : {atelier}
      </div>
    </div>
  );
}

export default TarfisSumeryEntry;
